export const preventDefault = (handler) => (evt) => {
  evt.preventDefault()
  return handler(evt)
}

// Thanks, @Bergi. https://stackoverflow.com/a/33292942
export const sleep = (durationInMilliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, durationInMilliseconds))
}
